import $ from 'jquery';
import _ from 'lodash';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';
import ConversationStore from '../stores/ConversationStore';
import MessageStore from '../stores/MessageStore';
import MemberStore from '../stores/MemberStore';

const ActionTypes = Constants.ActionTypes;

const checkRedirect = function (data) {
  // ja atbilde ir txt, tad pārveido uz json
  if (_.isString(data)) {
    data = JSON.parse(data);
  }

  if (data.url) {
    window.location = data.url;
    return true;
  }

  return false;
};

// atgriež info priekš vēstuļu atjaunošas, lai noteiktu izlasītās vēstules
const updateMessagesData = function (conversationID) {
  const message = MessageStore.getFirstMessage(conversationID);

  if (!message) {
    return null;
  }

  const lastUpdate = MessageStore.getSentMessagesUpdate(conversationID);

  return {
    update_messages_from_id: message.get('_id'),
    update_messages_last_update: lastUpdate,
    member_id: conversationID,
  };
};

const requestApi = function (data, type, postData) {
  // default type 'GET'
  type = typeof type !== 'undefined' ? type : 'GET';

  const apiWebroot = _.get(globals, 'apiWebroot', '/');
  let url;

  switch (data['action']) {
    case 'submit':
      url = `${apiWebroot}messages/send`;
      break;
    case 'message_delete':
      url = `${apiWebroot}messages/message_delete`;
      break;
    case 'conversations_delete':
      url = `${apiWebroot}messages/conversations_delete`;
      break;
    default:
      url = `${apiWebroot}messages/get`;
      break;
  }

  // Ja POST, tad pie url piekabina data vērtības
  if (type == 'POST') {
    if (!_.isEmpty(data)) {
      // saliek korektas GET vērtības
      url += `?${$.param(data)}`;
    }
    // post dati
    if (typeof postData !== 'undefined') {
      data = postData;
    }
  }

  const post = $.ajax({
    type,
    url,
    data,
    dataType: 'json',
  });

  return post;
};

const loadMessages = function (params, loadMoreClick) {
  if (!params && !params.member_id) {
    return false;
  }

  // loadMoreClick default vērtība - false
  loadMoreClick = typeof loadMoreClick !== 'undefined' ? loadMoreClick : false;

  const defaults = {
    member_id: null,
    load_messages: true,
    message_date: null,
  };

  // apvieno defaults ar params un izņem tukšos objekta ierakstus
  /* const data = _.chain(defaults)
    .assign(params)
    .pick(_.identity)
    .value(); */
  let data = params;
  for (let key in defaults) {
    if(!data.hasOwnProperty(key)) {
      data[key] = defaults[key];
    }
  }

  const id = data.member_id;

  // load
  AppDispatcher.dispatch({
    type: ActionTypes.MESSAGES_LOAD,
    conversationID: id,
    loadMoreClick,
  });

  const request = requestApi(data);

  // success
  request.done((data) => {
    if (checkRedirect(data)) {
      return;
    }

    AppDispatcher.dispatch({
      type: ActionTypes.MESSAGES_LOAD_SUCCESS,
      messages: data.messages,
      loadMoreClick,
      id,
      unread_conversations: data.unread_conversations,
      limitedMessages: data.limited_messages,
      hasPaid: data.has_paid,
    });
  });

  // fail
  request.fail((data) => {
    // location.reload(true);
    AppDispatcher.dispatch({
      type: ActionTypes.MESSAGES_LOAD_FAIL,
      data,
    });
  });

  return request;
};

// TODO If want to use websockets to show messages before they are actually sent..
// Need to figure out something with errors.
// How to show errors if there are any (for example too many equal messages sent today) during actual sending process.
// And.. then remove message which is already shown? Show for a moment and then remove if it's not actually sent?
// But that would be so strange.
// So probably can't show message before it's actually sent, because can't know if it's a valid message (for example, not blacklisted), and actually sent.
const webSocketSend = function (from, to, action, txt = "") {
  return false;

  /* if (!from || !to || !action) {
    return false;
  }

  const webSocket = MessageStore.getWebSocket();
  if (!webSocket) {
    return false;
  }

  const timestamp = Math.floor(Date.now() / 1000) * 1000;

  webSocket.send(JSON.stringify({ from, to, action, timestamp, txt }));

  // TODO nevar zināt vai nosūtīts, bet vismaz webSocket nav false
  return true; */
};

module.exports = {

  conversationsLoadMore(lastUpdate) {
    this.conversationsLoad(lastUpdate, 'less', false, true, false);
  },

  conversationsLoad(lastUpdate, conversationComparison, clickConversation, loadMore, loadMembersData, updateMessages) {
    if (MessageStore.getConversationsLoading()) {
      return;
    }

    // loadMore default vērtība - false
    loadMore = typeof loadMore !== 'undefined' ? loadMore : false;

    // load
    AppDispatcher.dispatch({
      type: ActionTypes.CONVERSATIONS_LOAD,
      loadMoreClick: loadMore,
    });

    AppDispatcher.dispatch({
      type: ActionTypes.MESSAGES_LOAD,
    });

    AppDispatcher.dispatch({
      type: ActionTypes.MEMBERS_LOAD,
    });

    let data = {
      load_messages: true,
      load_members: true,
      load_conversations: true,
      conversation_last_update: lastUpdate,
      conversation_comparison: 'less',
    };

    // pie katra update uzseto aktīvo saraksti
    if (clickConversation) {
      const currentID = ConversationStore.getCurrentID();
      if (currentID) {
        data.conversation_open = true;
        data.member_id = currentID;
      }

      // neielādē datus par lietotāju, ja nav atzīmēts loadMembersData
      if (!loadMembersData) {
        data.load_members = false;
      }

      // ielādēt info par atjaunotajām vēstulēm (izlasītajām)
      if (updateMessages) {
        data = _.assign(data, updateMessagesData(currentID));
      }
    }

    // jaunākus 'greater', vecākus 'less'
    if (conversationComparison) {
      data.conversation_comparison = conversationComparison;
    }

    // ielādēt/atjaunot datus par visiem lietotājiem
    if (loadMembersData) {
      const membersIds = MemberStore.getAllIds();
      if (!_.isEmpty(membersIds)) {
        data.member_ids = membersIds;
      }
    }

    const request = requestApi(data);

    // success
    request.done((data) => {
      if (checkRedirect(data)) {
        return;
      }

      AppDispatcher.dispatch({
        type: ActionTypes.MEMBERS_LOAD_SUCCESS,
        members: data.members,
        limitedMessages: data.limited_messages,
        hasPaid: data.has_paid,
      });

      let loadSucces = {
        type: ActionTypes.CONVERSATIONS_LOAD_SUCCESS,
        conversations: data.conversations,
        unread_conversations: data.unread_conversations,
        limitedMessages: data.limited_messages,
        hasPaid: data.has_paid,
      };

      // load More gadījumā
      if (loadMore) {
        loadSucces = _.assign(loadSucces, { loadMoreClick: true });
      }

      AppDispatcher.dispatch(loadSucces);

      AppDispatcher.dispatch({
        type: ActionTypes.MESSAGES_LOAD_SUCCESS,
        messages: data.messages,
        unread_conversations: data.unread_conversations,
        limitedMessages: data.limited_messages,
        hasPaid: data.has_paid,
      });
    });

    // fail
    request.fail((data) => {
      if (MessageStore.getFailedUpdateCount() >= 5) {
        location.reload(true);
      }

      AppDispatcher.dispatch({
        type: ActionTypes.CONVERSATIONS_LOAD_FAIL,
        data,
      });

      AppDispatcher.dispatch({
        type: ActionTypes.MESSAGES_LOAD_FAIL,
        data,
      });

      AppDispatcher.dispatch({
        type: ActionTypes.MEMBERS_LOAD_FAIL,
        data,
      });
    });
  },

  messagesLoadMoreClick(id, messageDate) {
    // load
    const data = {
      member_id: id,
      message_date: messageDate,
      conversation_open: true,
    };
    loadMessages(data, true);
  },

  clickConversation(id) {
    // click
    AppDispatcher.dispatch({
      type: ActionTypes.CONVERSATION_CLICK,
      conversationID: id,
    });

    // load
    AppDispatcher.dispatch({
      type: ActionTypes.MESSAGES_LOAD,
      conversationID: id,
    });

    const data = {
      member_id: id,
      load_messages: true,
      conversation_open: true, // lai var zināt, kurai no sarakstēm uzsetot, ka ir izlasīta
    };

    const request = requestApi(data);

    // success
    request.done((data) => {
      if (checkRedirect(data)) {
        return;
      }

      /* if (data.unread_conversations !== ConversationStore.getUnread()) {
        webSocketSend(id, _.get(globals, 'currentMember.id', null), 'read');
      } */

      AppDispatcher.dispatch({
        id,
        type: ActionTypes.MESSAGES_LOAD_SUCCESS,
        messages: data.messages,
        unread_conversations: data.unread_conversations,
        limitedMessages: data.limited_messages,
        openConversation: true,
      });
    });

    // fail
    request.fail((data) => {
      // location.reload(true);
      AppDispatcher.dispatch({
        type: ActionTypes.MESSAGES_LOAD_FAIL,
        data,
      });
    });
  },

  setActiveConversation(id) {
    const data = {
      member_id: id,
      conversation_open: true, // lai var zināt, kurai no sarakstēm uzsetot, ka ir izlasīta
    };

    const request = requestApi(data);

    // success
    request.done((data) => {
      if (checkRedirect(data)) {
        return;
      }

      AppDispatcher.dispatch({
        type: ActionTypes.CONVERSATION_ACTIVE,
        conversationID: id,
      });
    });

    // fail
    // request.fail(function(data) {
    //
    // });
  },

  createMessage(text, conversationID) {
    // var sent = webSocketSend(_.get(globals, 'currentMember.id', null), conversationID, 'send', text);

    /*
    if(sent !== false) {
      return false;
    }
    */

    AppDispatcher.dispatch({
      type: ActionTypes.MESSAGES_LOAD,
      conversationID,
      createMessage: true,
    });

    const newestMessage = MessageStore.getLastMessage(conversationID);
    let newestMessageDate = null;

    if (newestMessage) {
      newestMessageDate = newestMessage.get('created');
    }

    const data = {
      member_id: conversationID,
      load_messages: true,
      message_date: newestMessageDate,
      message_comparison: 'greater',
      action: 'submit',
      conversation_open: true,
    };

    // izmanto POSt
    // data kā GET parametri, text kā POST

    const request = requestApi(data, 'POST', { text });

    // success
    request.done((data) => {
      if (data.status == 'error') {
        AppDispatcher.dispatch({
          type: ActionTypes.MESSAGES_LOAD_FAIL,
          error: data.message,
        });
        return;
      }

      if (checkRedirect(data)) {
        return;
      }

        AppDispatcher.dispatch({
          type: ActionTypes.MESSAGES_LOAD_SUCCESS,
          messages: data.messages,
          createMessage: true,
          unread_conversations: data.unread_conversations,
          limitedMessages: data.limited_messages,
        });
    });

    // fail
    request.fail((data) => {
      // location.reload(true);

      AppDispatcher.dispatch({
        type: ActionTypes.MESSAGES_LOAD_FAIL,
        data,
      });
    });
  },

  // TODO If want to use websockets to show messages before they are actually sent..
  // Need to figure out something with errors.
  // How to show errors if there are any (for example too many equal messages sent today) during actual sending process.
  // And.. then remove message which is already shown? Show for a moment and then remove if it's not actually sent?
  // But that would be so strange.
  // So probably can't show message before it's actually sent, because can't know if it's a valid message (for example, not blacklisted), and actually sent.
  updateMessagesFromWebsockets(data, member_id) {
    return;
    /* let messages = [{
      _id: "websocket_"+data.timestamp,
      created: data.timestamp,
      deleted: false,
      member_id: member_id,
      read: false,
      sender_id: data.from,
      text: data.txt,
      updated: null
    }];

    AppDispatcher.dispatch({
      type: ActionTypes.MESSAGES_LOAD_SUCCESS,
      messages: messages,
    }); */
  },

  updateMessages(conversationID, messageDate, currentMemberId = null) {
    AppDispatcher.dispatch({
      type: ActionTypes.MESSAGES_LOAD,
      conversationID,
    });

    let data = {
      member_id: conversationID,
      conversation_open: true,
      load_messages: true,
      message_date: messageDate,
      message_comparison: 'greater',
    };

    data = _.assign(data, updateMessagesData(conversationID));

    const request = requestApi(data);

    // success
    request.done((data) => {
      if (checkRedirect(data)) {
        return;
      }

      // Here need to send 'read' update only if 'currentMemberId' is passed as function param
      /* if (currentMemberId) {
        webSocketSend(conversationID, currentMemberId, 'read');
      } */

      AppDispatcher.dispatch({
        type: ActionTypes.MESSAGES_LOAD_SUCCESS,
        messages: data.messages,
        unread_conversations: data.unread_conversations,
        limitedMessages: data.limited_messages,
        hasPaid: data.has_paid,
      });
    });

    // fail
    request.fail((data) => {
      // location.reload(true);

      AppDispatcher.dispatch({
        type: ActionTypes.MESSAGES_LOAD_FAIL,
        data,
      });
    });
  },

  deleteMessage(message) {
    AppDispatcher.dispatch({
      type: ActionTypes.MESSAGE_DELETE,
      message,
    });

    // ajax
    const data = {
      action: 'message_delete',
      message_id: message.get('_id'),
      member_id: message.get('member_id'),
    };

    const request = loadMessages(data);
    // fail
    request.fail((data) => {
      // location.reload(true);
      // TODO
    });
  },

  reportMessage(message) {
    AppDispatcher.dispatch({
      type: ActionTypes.MESSAGE_REPORT,
      message,
    });

    // ajax
    const data = {
      action: 'message_report',
      message_id: message.get('_id'),
    };

    const request = loadMessages(data);

    // success
    request.done((response) => {
      AppDispatcher.dispatch({
        type: ActionTypes.MESSAGE_REPORT_SUCCESS,
        message,
      });
    });

    // fail
    request.fail((response) => {
      AppDispatcher.dispatch({
        type: ActionTypes.MESSAGE_REPORT_FAIL,
        message,
      });
    });
  },

  // atzīmēt saraksti
  checkedConversation(conversationID, status) {
    AppDispatcher.dispatch({
      type: ActionTypes.CONVERSATION_CHECKED,
      conversationID,
      status,
    });
  },

  deleteConversations() {
    const checkedConversations = ConversationStore.getChecked();

    // nav atzīmētas
    if (_.isEmpty(checkedConversations)) {
      return false;
    }

    // no objekt keys izveido masīvu, tālak padod ajax pieprasījumam
    const checkedConversationsKeys = Object.keys(checkedConversations);

    // ajax
    const data = {
      action: 'conversations_delete',
      conversations_ids: checkedConversationsKeys,
    };

    const request = requestApi(data);

    request.done((data) => {
      AppDispatcher.dispatch({
        type: ActionTypes.CONVERSATIONS_DELETE,
        conversations_ids: checkedConversationsKeys,
      });
    });

    request.fail((data) => {
      //
    });
  },

  deleteConversation(conversationId) {
    if (!conversationId) {
      return false;
    }

    const data = {
      action: 'conversations_delete',
      conversations_ids: [conversationId],
    };

    const request = requestApi(data);

    request.done(() => {
      AppDispatcher.dispatch({
        type: ActionTypes.CONVERSATIONS_DELETE,
        conversations_ids: [conversationId],
      });
    });

    request.fail(() => {
      //
    });
  },

  // Dzēst 1 saraksti, šobrīd var dzēst vairākas vienlaicīgi
  // deleteConversation: function (conversationID) {
  // 	var self = this;
  // 	var actualConversationID = ConversationStore.getCurrentID();
  //
  // 	AppDispatcher.dispatch({
  // 		type: ActionTypes.CONVERSATION_DELETE,
  // 		conversationID: conversationID
  // 	});
  //
  // 	// ajax
  // 	var data = {
  // 		action: 'conversation_delete',
  // 		conversation_id: conversationID
  // 	};
  //
  // 	var request = requestApi(data);
  //
  // 	// ja aktuālā/atvērtā sarakste tiek dzēsta, tad nākošai ielādē datus
  // 	if (conversationID != actualConversationID) {
  // 		return;
  // 	}
  //
  // 	// gaida, kad tik uzsetots jauns sarakstes ID
  // 	var i = 0;
  // 	var waitForId = setInterval(function(){
  //
  // 		var newId = ConversationStore.getCurrentID();
  //
  // 		// ir nomainījies sarakstes ID
  // 		if (newId != conversationID) {
  // 			loadMessages({member_id: newId});
  // 			self.setActiveConversation(newId);
  // 			clearInterval(waitForId);
  // 		}
  //
  // 		// kādu laiku nav bijušas izmaiņas
  // 		if (i == 500) {
  // 			clearInterval(waitForId);
  // 		}
  //
  // 		i++;
  // 	}, 5);
  // }

};
